jQuery(function($){
  $(window).on('load', function(){
    var header_wrap = $('.header-wrapper'),
        header_wrap_par = header_wrap.parent();

    if ( header_wrap.hasClass('header_fixed') ) {
      header_wrap_par.removeClass('main_header_fixed');
    } else {
      header_wrap_par.addClass('main_header_fixed');
    }
  });

  var feat_col_slide = $('.feat_col_slide');
  if ( feat_col_slide.length > 0 ) {
      var feat_slide = new Swiper('.feat_col_slide .swiper-container', {
          slidesPerView: 1,
          spaceBetween: 15,
          pagination: {
            el: '.feat_col_slide .pagination',
            clickable: true,
          },
          breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              1025: {
                slidesPerView: 3,
                spaceBetween: 90,
              }
          }
      });
  }

  $(document).on('click', '#btn-create-another', function(x){
    x.preventDefault();

    window.location.replace("https://thecookiebox.com.au/collections/box-of-cookies");
  });

  var location = $('.location_slide');
  if ( location.length > 0 ) {
    var loc_slide = new Swiper('.location_slide .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: '.location_slide .pagination',
        clickable: true,
      },
      breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
      }
    });
  }

  var monthly_slide = $('.montly-special .swiper-container');
  if ( monthly_slide.length > 0 ) {
    var monthly_slider = new Swiper('.montly-special .swiper-container', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      navigation: {
        nextEl: ".montly-special .next",
        prevEl: ".montly-special .prev",
      },
      allowTouchMove: false
    });
  }

  var cotm_slide = $('.cotm_section  .swiper-container');
  if ( cotm_slide.length > 0 ) {
    var cotm_slider = new Swiper('.cotm_section .swiper-container', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      // autoHeight: true,
      navigation: {
        nextEl: ".cotm_section .next",
        prevEl: ".cotm_section .prev",
      },
      allowTouchMove: false
    });
  }

  var delivery = $('.delivery_slider');
  if ( delivery.length > 0 ) {
    var del_slider = new Swiper('.delivery_slider .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 15,
      autoHeight: true,
      pagination: {
        el: '.delivery_slider .pagination',
        clickable: true,
      },
      breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 88
          }
      }
    });
  }

  var prod_tab = $('.prod_tabs'),
      prod_tab_title = prod_tab.find('.tab_title_item'),
      prod_tab_content = prod_tab.find('.tab_item');

  prod_tab_title.find('span').click(function(){
    var this_par = $(this).parent(),
        tab_target = this_par.data('tab'),
        target_elem = $('#' + tab_target);

    prod_tab_title.not(this_par).removeClass('active_title');
    prod_tab_content.not(target_elem).removeClass('active_content');

    this_par.addClass('active_title');
    target_elem.addClass('active_content');
  });

  
  $('a[href^="#"]').each(function() {
    // Add a class or modify the element to look like a button
    $(this).addClass('anchor-button');

    var sticky_header = $('sticky-header'),
        sticky_header_height = sticky_header.height();
      
    // Optionally, if you want to prevent the default behavior
    $(this).on('click', function(event) {
      event.preventDefault();
      // You can also add smooth scroll or other effects here
      const target = $(this).attr('href');
      if (target !== '#') {
        $('html, body').animate({
            scrollTop: $(target).offset().top - sticky_header_height
        }, 1000);
      }
    });
  });
});